import * as React from 'react';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { DeviceFile } from 'shared/models';
import { Dictionary, values } from 'lodash';

require('./deviceFilesSection.css');

export type Props = {
    buildingId: string | null;
    deviceId: string;
    files: Dictionary<DeviceFile>;
    onClickDelete: (fileId: string) => void;
};

const oneKilobyte = 1024;
const oneMegabyte = 1024 * 1024;

export const formatSize = (size: number) =>
    size >= oneMegabyte
        ? `${Math.round(size * 10 / oneMegabyte) / 10} MB`
        : size >= oneKilobyte
            ? `${Math.round(size / oneKilobyte)} KB`
            : `${size} bytes`
;

// Show newer files first
const sortByCreated = (a: DeviceFile, b: DeviceFile) => moment.utc(b.created).valueOf() - moment.utc(a.created).valueOf();

export const DeviceFilesSection = ({ buildingId, deviceId, files, onClickDelete }: Props) => {
    const { t } = useTranslation();
    return (
        <section id="device-commands-section">
            <header>
                <h2>{ t('DEVICE.COMMANDS.FILES') }</h2>
            </header>
            <table style={ { maxWidth: '640px' } } className="ui single line compact table">
                <colgroup>
                    <col style={ { width: '50%' } }/>
                    <col style={ { width: '15%' } }/>
                    <col style={ { width: '30%' } }/>
                    <col style={ { width: '5%' } }/>
                </colgroup>
                <thead>
                    <tr>
                        <th>{ t('DEVICE.COMMANDS.FILE_NAME') }</th>
                        <th style={ { textAlign: 'right' } }>{ t('DEVICE.COMMANDS.FILE_SIZE') }</th>
                        <th>{ t('DEVICE.COMMANDS.FILE_CREATED') }</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    { buildingId && files && values(files).sort(sortByCreated).map(({ fileId, filename, size, created }: DeviceFile) =>
                        <tr key={ fileId }>
                            <td>
                                <a href={ `/api/buildings/${buildingId}/devices/${deviceId}/files/${fileId}` }>
                                    { filename }
                                </a>
                            </td>
                            <td style={ { textAlign: 'right' } }>
                                { formatSize(size) }
                            </td>
                            <td>
                                { moment(created).calendar() }
                            </td>
                            <td style={ { textAlign: 'right' } }>
                                <button
                                    type="button"
                                    className="ui tiny basic icon button"
                                    title={ t('COMMAND.DELETE') }
                                    onClick={ () => onClickDelete(fileId) }
                                >
                                    <i className="delete icon"/>
                                </button>
                            </td>
                        </tr>
                    ) }
                    {!files &&
                        <tr>
                            <td colSpan={ 4 } style={ { opacity: .5 } }>
                                { t('LOADING') }
                            </td>
                        </tr>
                    }
                    {files && Object.keys(files).length === 0 &&
                        <tr>
                            <td colSpan={ 4 } style={ { opacity: .5 } }>
                                { t('DEVICE.COMMANDS.NO_FILES') }
                            </td>
                        </tr>
                    }
                </tbody>
            </table>
        </section>
    );
};
